module.exports = __webpack_public_path__ + "static/media/long-term.28c68a5d.svg";